import { cn } from "@/lib/utils";

type LogoProps = {
  className?: string;
  markClassName?: string;
  textClassName?: string;
};

export function Logo({ className, markClassName, textClassName }: LogoProps) {
  return (
    <div className={cn("inline-flex items-center gap-3", className)}>
      <svg
        aria-hidden="true"
        className={cn("h-10 w-10", markClassName)}
        fill="none"
        viewBox="0 0 40 40"
      >
        <path
          d="M18.21 7.67 5.16 29.76c-1.37 2.32.3 5.24 2.99 5.24h4.14c1.25 0 2.4-.67 3.02-1.76l6.51-11.37a3.47 3.47 0 0 0-.01-3.47l-3.6-6.13a4.54 4.54 0 0 1 0-4.6Z"
          fill="#4077F6"
        />
        <path
          d="m21.79 7.67 13.05 22.09c1.37 2.32-.3 5.24-2.99 5.24h-4.14c-1.25 0-2.4-.67-3.02-1.76l-6.51-11.37a3.47 3.47 0 0 1 .01-3.47l3.6-6.13a4.54 4.54 0 0 0 0-4.6Z"
          fill="#4077F6"
        />
        <circle cx="20" cy="31" fill="#93B5FF" r="4" />
      </svg>
      <span className={cn("text-[28px] font-bold leading-none tracking-normal", textClassName)}>
        Fin
      </span>
    </div>
  );
}
